import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import { Icon } from "@/ds";

import { useGanttContext } from "../gantt.context";
import styles from "../gantt.module.scss";
import type { GanttRowViewProps } from "../types-gantt";
import { GanttMarkerView } from "./view-marker";

/** Linha do corpo: as células fixas, a área temporal (grade, conteúdo da tela, marcos e Hoje) e o ⋮. */
export function GanttRowView({ row }: GanttRowViewProps) {
  const {
    gridLines,
    todayStyle,
    todayTestId,
    withActions,
    classNames: partClassNames,
  } = useGanttContext();
  const { actions } = row;

  return (
    <div
      className={classNames(styles.row, partClassNames.row, row.className)}
      style={row.style}
      data-testid={row.testId}
      role="row"
    >
      {row.cells.map((cell) => (
        <div
          key={cell.key}
          className={classNames(styles.cell, partClassNames.cell, cell.className)}
          style={cell.style}
          data-spanned={cell.spanned || undefined}
          role={cell.role}
        >
          {cell.spanned ? <div className={styles.cellSpanInner}>{cell.content}</div> : cell.content}
        </div>
      ))}
      <div className={classNames(styles.track, partClassNames.track)} role="cell">
        {gridLines.map((line) => (
          <span key={line.key} className={styles.gridLine} style={line.style} aria-hidden />
        ))}
        {row.content}
        {row.markers.map((marker) => (
          <GanttMarkerView key={marker.key} marker={marker} />
        ))}
        {todayStyle ? (
          <span className={styles.today} style={todayStyle} data-testid={todayTestId} aria-hidden />
        ) : null}
      </div>
      {withActions ? (
        <div className={classNames(styles.actionsCell, partClassNames.actions)} role="cell">
          {actions.kind === "menu" ? (
            <Button
              type="button"
              icon={<Icon name="ellipsis-v" size={14} />}
              rounded
              text
              severity="secondary"
              className="p-button-row-actions"
              aria-label={actions.label}
              aria-haspopup="menu"
              onClick={actions.onOpen}
              data-testid={actions.testId}
            />
          ) : actions.kind === "disabled" ? (
            <Button
              type="button"
              icon={<Icon name="ellipsis-v" size={14} />}
              rounded
              text
              severity="secondary"
              className="p-button-row-actions"
              aria-label={actions.label}
              disabled
            />
          ) : actions.kind === "node" ? (
            actions.node
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
GanttRowView.displayName = "Gantt.Row";
